// extracted by mini-css-extract-plugin
export default {"title":"styles_title__DK7df","description":"styles_description__C4eOX"};